import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Udgået",
  "Spare part list": "Liste over reservedele",
  "Download Excel": "Download Excel",
  "Recent search list": "Liste over seneste søgninger",
  "No data": "Ingen data tilgængelige for de indtastede søgeparametre",
  "spare part": "Reservedel",
  "none": "Ingen",
  "no value": "ingen værdi",
  "No results found": "Ingen resultater fundet",
  "Spare parts for": "Reservedele til",
  "Could not load cumulated data": "Kunne ikke indlæse kumulerede data",
  "commissioning part": "idriftsættelse af del",
  "wear part": "sliddele",
  "Search": "Søg efter",
  "Tk": "Tk",
  "Spare part number": "Reservedelsnummer",
  "drawing": "Tegning",
  "Products for": "Produkter til",
  "Available": "Tilgængelig",
  "MM": "MM",
  "The entered order code is invalid": "Den indtastede ordrekode er ugyldig",
  "Recommended": "Anbefalet",
  "No data available for the entered search parameters": "Ingen data tilgængelige for de indtastede søgeparametre",
  "Search spare parts": "Søg efter reservedele",
  "Order code / product root / serial number": "Ordrekode / produktrod / serienummer",
  "Characteristic": "Karakteristisk",
  "Please enter an order code": "Indtast venligst en bestillingskode",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "Med hensyn til kvalitets- og sikkerhedsaspekter anbefaler Endress+Hauser på det kraftigste, at der udelukkende anvendes originale Endress+Hauser-reservedele. \nInstrumentet må kun vedligeholdes og repareres af kvalificeret personale. \nEnhedsdokumentationen gældende standarder og lovkrav samt eventuelle certifikater skal overholdes!",
  "Maintenance advice": "Råd om vedligeholdelse",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Hvilke(t) produkt(er) kan min reservedel bruges til? \nIndlæsning af reservedelens bestillingskode (f.eks. 71002865 eller XPD0024) viser de relevante enheder, som denne reservedel kan bruges i.",
  "tool": "værktøj",
  "Production numbers": "Produktionstal",
  "New alternative": "Nyt alternativ",
  "There are no items selected. Please use the checkboxes to make your selection": "Advarsel",
  "Service segmentation": "Segmentering af tjenester",
  "Seg": "Seg",
  "Valid": "Gyldig",
  "Pos": "Pos",
  "Value": "Værdi",
  "service segmentation 2": "Dele, der kræver grundlæggende viden. Vellykket deltagelse i E+H-grundtræning er en forudsætning.",
  "Phase out date": "Udfasningsdato",
  "service segmentation 1": "Dele, der kræver grundlæggende viden.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Hvilke reservedele er tilgængelige til mit produkt? \\Ved at indtaste bestillingskoden (f.eks. FTC260-AA2A1 eller PMC51-BA21JB1CGBTDJB) eller produkt-id\u0027et (f.eks. FTC260 eller 83F50) får du vist de relevante reservedele.",
  "Set filter": "Indstil filter",
  "Search date": "Dato for søgning",
  "Group": "Gruppe",
  "Warning": "Der er ikke valgt nogen elementer. Brug venligst afkrydsningsfelterne til at foretage dit valg",
  "Description": "Beskrivelse",
  "Cancel": "Annuller",
  "service segmentation 4": "Dele til reparation på fabrikken. Ekspertviden er obligatorisk.",
  "service segmentation 3": "Dele, der kræver specialiseret viden. Succesfuld deltagelse i E+H Advanced Training er en forudsætning.",
  "Drawing Position Number": "Tegningens positionsnummer",
  "Spare parts search": "Find reservedele",
  "Confirm": "Bekræft",
  "Ordercode too short": "Bestillingskode for kort",
  "Product status": "Produktets status",
  "Open": "Åben",
  "Clear": "Klar",
  "PDF file with assembly instructions": "PDF-fil med monteringsvejledning",
  "Search products": "Søg efter produkter",
  "Export": "Eksport",
  "Production date": "Produktionsdato",
  "Order stop": "Bestil stop",
  "Calibration until": "Kalibrering indtil",
  "PDF file with compatibility information": "PDF-fil med oplysninger om kompatibilitet",
  "Add selection to cart": "Læg udvalget i kurven",
  "Mounting advices": "Råd om montering",
  "Recommended parts only": "Kun anbefalede dele",
  "not applicable": "åben",
  "accessories": "tilbehør",
  "Cumulative spare parts list": "Kumulativ reservedelsliste",
  "YYYY": "YYYY",
  "Title": "Titel",
  "Error": "Fejl",
  "Ordercode too long": "Bestillingskode for lang",
  "Functions": "Funktioner",
  "Rec": "Rec",
  "Type": "Type",
  "Spare sensor until": "Reservesensor indtil",
  "Spare parts until": "Reservedele indtil",
  "Filter": "Filter",
  "Check all": "Tjek alle",
  "Order code": "Bestillingskode",
  "Repair until": "Reparation indtil",
  "Tag": "Tag",
  "Ok": "Ok",
  "Category code": "Kategori kode",
  "Phase out": "Udfasning",
  'Compatibility advices': 'Yderligere dokumenter',
  'Co.': 'Yderl. dok.',
} as LocalizedDictionary;
